import {
  PaymentType,
  StripeOrderDTO,
  StripeOrderStatus,
} from "./StripeOrderDTO.ts";

const RUNNING_INSTALLMENT_PLAN_STATUSES = [
  StripeOrderStatus.InstallmentPaid,
  StripeOrderStatus.InstallmentDelinquent,
];

type InstallmentAttempt = StripeOrderDTO["installmentInvoices"][number];

function lastFailedAttempts(
  attempts: InstallmentAttempt[],
): InstallmentAttempt[] {
  let firstFailedIndex = attempts.length;
  while (
    firstFailedIndex > 0 &&
    attempts[firstFailedIndex - 1].status === "failed"
  )
    firstFailedIndex--;
  return attempts.slice(firstFailedIndex);
}

function attemptsLabel(count: number): string {
  return count === 1 ? "1 tentativo" : `${count} tentativi`;
}

export function describeFailingInstallments(
  order: Pick<
    StripeOrderDTO,
    "paymentType" | "status" | "installmentInvoices" | "numberOfFailedCharges"
  >,
): string | undefined {
  if (order.paymentType !== PaymentType.Installments) return undefined;
  if (!RUNNING_INSTALLMENT_PLAN_STATUSES.includes(order.status))
    return undefined;

  const failedAttempts = lastFailedAttempts(order.installmentInvoices ?? []);
  if (failedAttempts.length > 0) {
    const failedInstallments = new Set(
      failedAttempts.map((attempt) => attempt.installmentNumber),
    ).size;
    return failedInstallments === 1
      ? `Ultima rata fallita (${attemptsLabel(failedAttempts.length)})`
      : `Ultime ${failedInstallments} rate fallite (${attemptsLabel(failedAttempts.length)})`;
  }

  const failedCharges = order.numberOfFailedCharges ?? 0;
  if (failedCharges === 0) return undefined;
  return failedCharges === 1
    ? "1 tentativo di pagamento fallito"
    : `${failedCharges} tentativi di pagamento falliti`;
}
